import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useDocumentTitle from '../../../hooks/useDocumentTitle';

const CustomerDetailsPageActionButtons = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const onClickingBackButton = () => {
    return navigate('/customers');
  };

  return (
    <>
      <Button
        id="customer-profile-back"
        key="back"
        variant="contained"
        color="primary"
        onClick={onClickingBackButton}
        className="action-button"
        sx={{ marginLeft: theme.spacing(1) }}
      >
        Back
      </Button>
    </>
  );
};

export default CustomerDetailsPageActionButtons;
